import type { FaireProductEntity } from "../../entity_types/product";

export const p_w5k3kjqdsm: FaireProductEntity = {
  token: "p_w5k3kjqdsm",
  type: "product",
  name: "Overall Ruffle Romper - FloralP2697--6",
  brandToken: "b_bp9ko7sqyj",
  brandName: "Angle",
  imageUrl:
    "https://cdn.faire.com/fastly/d5839f65dce746d83079e6014712ba1e87407128bd325f59645ed55e04f31e4c.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/5d2acb2d126fdb46d28bdb1ce73fb0b465933f4cbd298d4a37ee7f2051fdbb7a.jpeg",
  ],
  priceDollars: 5.59,
  description:
    "Elevate your baby's summer style with this overall style romper featuring a delightful daisy pattern and adorable front ruffle. Great for sunny day adventures – cute and comfy all in one!\n• Made of comfortable bamboo jersey fabric\n• Convertable cross straps for the perfect fit as your baby grows\n• Convenient snap closures for easy diaper changes\n\n• Material: Bamboo Jersey (97% Rayon Made from Bamboo,\n3% Spandex)\n• Size: 3-6 mo, 6-12 mo\n• Care Instructions: Machine Wash Cold. Tumble Dry Low.",
  tags: [],
  msrpDollars: 35.9,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-25T20:54:59.902Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
